export default {
  title: 'Comenzi',
};
